<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="'Teacher Comment List'" :directory="$t('transaction')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
            </div>
        </div>

        <app-table
            :id="tableId"
            :options="options"
            @action="getListAction"
        />

        <student-list-wizard 
            v-if="isStudentListModalActive" 
            :row-data="rowData"
            :CourseId="CourseId"
            :CourseName="CourseName"
            :selected-url="selectedUrl"
            :modal-id="formId" 
            :table-id="tableId" 
            @close-modal="closeStudentListModal" />
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {Schema} from './Schema';
import StudentListFornWizard from "./StudentListFornWizard";
export default {
    extends: CoreLibrary,
    name: "ContinueList",
    mixins: [Schema],
    components: {
        'student-list-wizard': StudentListFornWizard
    },
	data() {
		return {
            CourseId : '',
            CourseName : ''
        }
    },
    created() {
        this.options.columns = [...this.tableColumns];
    },
	mounted() {
		window.handleListStudent = (id,course_name) => {
            this.CourseId = id;
            this.CourseName = course_name;
			this.openListStudent(id,course_name);
		};
    },
    methods: {
        openAddEditModal() {
            this.isStudentListModalActive = true;
        },
        openListStudent(id){
            // this.selectedUrl = `transaction/student-list-with-course/${id}`;
            this.openAddEditModal();
        },
        closeStudentListModal() {
            let m_id = `#STUDENTLIST-form`;
            $(m_id).modal('hide');
            this.isStudentListModalActive = false;
			this.reSetData();
        },

        getListAction(rowData, actionObj, active) {
        },
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
    },
}
</script>
